import {getKey} from '../../util/panels';
import {LayedOutPanel, PanelType} from '../../util/panelTypes';
import {getTitleFromConfig as getBarChartTitleFromConfig} from '../PanelBarChart/common';
import {BarChartConfig} from '../PanelBarChart/types';
import {MediaBrowserPanelConfig} from '../PanelMediaBrowser';
import {getTitleFromConfig as getMediaBrowserTitleFromConfig} from '../PanelMediaBrowser/common';
import {
  getTitleFromConfig as getParallelCoordTitleFromConfig,
  PCConfig,
} from '../PanelParallelCoord/common';
import {getTitleFromConfig as getRunsLinePlotTitleFromConfig} from '../PanelRunsLinePlot/common';
import {RunsLinePlotConfig} from '../PanelRunsLinePlot/types';
import {
  getTitleFromConfig as getScalarChartTitleFromConfig,
  ScalarChartConfig,
} from '../PanelScalarChart/common';
import {
  getTitleFromConfig as getScatterPlotTitleFromConfig,
  ScatterPlotConfig,
} from '../PanelScatterPlot/common';

const getTitleFromAnyConfig = (panelType: PanelType, panel: LayedOutPanel) => {
  const config = panel.config;
  switch (panelType) {
    case 'Bar Chart':
      return getBarChartTitleFromConfig(config as BarChartConfig);
    case 'Parallel Coordinates Plot':
      return getParallelCoordTitleFromConfig(config as PCConfig);
    case 'Run History Line Plot':
      return getRunsLinePlotTitleFromConfig(config as RunsLinePlotConfig);
    case 'Scalar Chart':
      return getScalarChartTitleFromConfig(config as ScalarChartConfig);
    case 'Scatter Plot':
      return getScatterPlotTitleFromConfig(config as ScatterPlotConfig);
    case 'Media Browser':
      return getMediaBrowserTitleFromConfig(config as MediaBrowserPanelConfig);
    default:
      return getKey(panel);
  }
};

export function normalizeValue(input: string): string {
  return input.replace(/[\u00A0]/g, ' ');
}

export function trimAndNormalizeCommaSeparatedValues(input: string): string {
  return input
    .split(',')
    .map(value => normalizeValue(value).trim())
    .join(',');
}

export const getTrimmedTitleFromAnyConfig = (
  panelType: PanelType,
  panel: LayedOutPanel
) => {
  const panelTitle = getTitleFromAnyConfig(panelType, panel);
  return panelTitle ? trimAndNormalizeCommaSeparatedValues(panelTitle) : null;
};
